/**
 * Checks if local storage and cookies are supported in the current environment.
 * In sandboxed iframes (like AdSense preview), accessing these will throw a SecurityError.
 */
export const isStorageSupported = (): boolean => {
    try {
        // Test localStorage
        const testKey = '__storage_test__';
        window.localStorage.setItem(testKey, testKey);
        window.localStorage.removeItem(testKey);
        
        // Test document.cookie access
        if (document.cookie === undefined) {
            return false;
        }
        
        return true;
    } catch (e) {
        return false;
    }
};
